const onlyNumbersRegex = /^\d+$/
export default onlyNumbersRegex
